import gql from 'graphql-tag';
import ASSET_FRAGMENT from './Asset';
const DOLCH_DYNAMITE_ACTIVITY_FRAGMENT = gql `
  fragment DolchDynamiteActivityFragment on DolchDynamiteActivity {
    rounds {
      id
      steps {
        id
        answer
        answerAudio {
          audio {
            ...AssetFragment
          }
        }
      }
    }
  }
  ${ASSET_FRAGMENT}
`;
export default DOLCH_DYNAMITE_ACTIVITY_FRAGMENT;
